import { EventEmitter, Injectable, Type } from '@angular/core';
import { DialogContentData } from './generic-dialog/generic-dialog.component';
import { IconPickerComponent, IconPickerData } from './icon-picker/icon-picker.component';
import { SignatureContentData } from './signature-pad-dialog/signature-pad-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class UserFeedbackService {

  showSnackBar: EventEmitter<string> = new EventEmitter()
  loading: EventEmitter<boolean> = new EventEmitter()

  showDialog: EventEmitter<DialogContentData> = new EventEmitter()
  showIconPicker: EventEmitter<IconPickerData> = new EventEmitter()
  showSignature: EventEmitter<SignatureContentData> = new EventEmitter()
  
  constructor() { }
}
